import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-file-upload',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="space-y-2">
      <input
        type="file"
        #fileInput
        multiple
        accept="image/*"
        class="hidden"
        (change)="onFileSelected($event)"
        [attr.disabled]="isDisabled"
      />
      
      <button
        type="button"
        [class.opacity-50]="isDisabled"
        [class.cursor-not-allowed]="isDisabled"
        [attr.disabled]="isDisabled"
        (click)="!isDisabled && fileInput.click()"
        class="w-full p-4 border-2 border-dashed border-gray-300 rounded-lg text-gray-600 hover:border-vodafone-red hover:text-vodafone-red transition-colors text-center"
      >
        {{ selectedFiles.length ? 'Add more screenshots' : 'Add screenshots (optional)' }}
      </button>

      <div *ngIf="selectedFiles.length > 0" class="space-y-2">
        <div
          *ngFor="let file of selectedFiles; let i = index"
          class="flex items-center justify-between p-2 bg-gray-50 rounded"
        >
          <span class="text-sm text-gray-600 truncate">{{ file.name }}</span>
          <button
            type="button"
            [attr.disabled]="isDisabled"
            (click)="!isDisabled && removeFile(i)"
            class="ml-2 text-red-600 hover:text-red-800 disabled:opacity-50 disabled:cursor-not-allowed"
          >
            Remove
          </button>
        </div>
      </div>
    </div>
  `
})
export class FileUploadComponent {
  @Input() isDisabled = false;
  @Output() filesChange = new EventEmitter<File[]>();

  selectedFiles: File[] = [];

  onFileSelected(event: Event): void {
    if (this.isDisabled) return;
    
    const input = event.target as HTMLInputElement;
    if (input.files?.length) {
      const newFiles = Array.from(input.files);
      this.selectedFiles = [...this.selectedFiles, ...newFiles];
      this.filesChange.emit(this.selectedFiles);
    }
  }

  removeFile(index: number): void {
    if (this.isDisabled) return;
    
    this.selectedFiles = this.selectedFiles.filter((_, i) => i !== index);
    this.filesChange.emit(this.selectedFiles);
  }
}